import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Separator } from "@/components/ui/separator";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { signOut } from "@/lib/auth";
import { ArrowDown2 } from "iconsax-react";
import { FC } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

const appVersion = __APP_VERSION__;

const handleSignOut = async () => {
  try {
    await signOut();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    toast.error("Error al cerrar sesión", { description: error.message });
  }
};

const UserDropdown: FC = () => {
  const { data: userProfile } = useCurrentUserProfile();

  if (!userProfile) {
    return null;
  }

  // Get the first letter of the name
  const initials = userProfile.name.charAt(0).toUpperCase();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="relative flex max-w-sm items-center gap-2 rounded-full bg-[##E3E3F3] bg-[#E3E3F3] px-4 py-2">
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-sm bg-[#615CB7] text-white">
            {initials}
          </span>
          <span className="truncate text-[#293038]">{userProfile.name}</span>
          <ArrowDown2 size={24} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-w-sm">
        <div className="p-4 pb-5 text-center">
          <div className="text-base font-bold text-[#4F5D6D]">
            {userProfile.name}
          </div>
          <div className="text-xs text-[#4F5D6D]">{userProfile.email}</div>
        </div>

        <Separator />

        <DropdownMenuItem asChild>
          <Link to="/company">Perfil de la empresa</Link>
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={handleSignOut}>
          Cerrar sesión
        </DropdownMenuItem>

        <div className="mb-1 mt-4 text-center text-xs text-muted-foreground opacity-40">
          versión enduser-{appVersion}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserDropdown;
